<div class="card" [class.p-p-0]="isSidebar">
  <p-contextMenu #cm [model]="contextMenuItems" (onShow)="buildContextMenu()" appendTo="body"></p-contextMenu>
  <p-table
    [value]="filteredEvents"
    [columns]="cols"
    [paginator]="true"
    [rows]="15"
    styleClass="p-datatable-gridlines"
    [tableStyle]="{'min-width': '1050px'}"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    selectionMode="single"
    dataKey="id" [sortable]="true"
    [(contextMenuSelection)]="selectedEvent"
    [contextMenu]="cm" [class.captionNoHeader]="isSidebar"
    [(selection)]="selectedEvent"
    (onRowSelect)="editEvent(selectedEvent)"
    (onRowUnselect)="selectedEvent=null"
  >


    <ng-template pTemplate="caption">
      <div class="p-d-flex p-ai-center">
        <span [class.p-ml-3]="isSidebar">Events</span>
        <div class="p-ml-auto p-d-flex">
          <p-dropdown
            [options]="dataIsOperatorList"
            [(ngModel)]="selectedDateFilter"
            (onChange)="onFilterChange($event)"
            showClear="true"
            (onClear)="resetFilter($event)"
            styleClass="event-filter"
            [style]="{ width: '150px' }"
            appendTo="body"
          >
          </p-dropdown>

          <div
            *ngIf="selectedDateFilter === 'Custom'"
            class="p-ml-2 p-d-flex gap-2"
          >
            <p-calendar
              [(ngModel)]="dateFrom"
              [showIcon]="true"
              placeholder="From Date"
              (onSelect)="onCustomDateChange()"
              [maxDate]="dateTo || undefined"
              [style]="{ width: '150px' }"
              placeholder="mm/dd/yyyy"
              dateFormat="mm/dd/yy"
              appendTo="body"
            >
            </p-calendar>

            <p-calendar
              [(ngModel)]="dateTo"
              [showIcon]="true"
              placeholder="To Date"
              (onSelect)="onCustomDateChange()"
              [minDate]="dateFrom || undefined"
              [style]="{ width: '150px' }"
              placeholder="mm/dd/yyyy"
              dateFormat="mm/dd/yy"
              appendTo="body"
            >
            </p-calendar>
          </div>

          <span
            class="btnBarsKanban"
            pTooltip="Refresh List"
            tooltipPosition="top"
            (click)="fetchEvents()"
          >
            <i class="pi pi-refresh p-cursor-pointer"></i>
          </span>
          <span
            class="btnBarsKanban"
            pTooltip="Create New Event"
            tooltipPosition="top"
          >
            <i
              class="pi pi-plus p-cursor-pointer"
              (click)="openCreateEventModal()"
            ></i>
          </span>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th *ngFor="let col of cols" [pSortableColumn]="col.field" style="white-space: nowrap">
          {{ col.header }}
          <p-sortIcon *ngIf="col.sort"  [field]="col.field"></p-sortIcon>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-event>
      <tr [pContextMenuRow]="event" [pSelectableRow]="event">
        <td>{{ event.calendarEvent?.name}}</td>
        <td style="white-space: nowrap">{{ event.calendarEvent?.startDate | localDate:'dateTime'}}</td>
        <td style="white-space: nowrap">{{ event.calendarEvent?.endDate | localDate:'dateTime'}}</td>
        <td>
          <div
            class="description-cell"
            [pTooltip]="
              (event.calendarEvent?.description | stripHtml).length > 50
                ? (event.calendarEvent?.description | stripHtml)
                : null
            "
            tooltipPosition="top"
            [tooltipStyleClass]="'description-tooltip'"
          >
            {{
              (event.calendarEvent?.description | stripHtml).length > 50
                ? (event.calendarEvent?.description | stripHtml | slice : 0 : 50) + '...'
                : (event.calendarEvent?.description | stripHtml)
            }}
          </div>
        </td>
        <td class="no-padding">
          <div class="flex align-items-center gap-2">
            <p-avatarGroup styleClass="mb-3">
              <p-avatar
                *ngFor="
                  let attendee of processAttendees(event.attendees).slice(0, 2)
                "
                [label]="attendee.initials"
                [pTooltip]="attendee.name"
                tooltipPosition="top"
                [style]="{ 'background-color': attendee.color }"
                shape="circle"
                size="normal"
              >
              </p-avatar>
              <p-avatar
                *ngIf="processAttendees(event.attendees).length > 2"
                [label]="'+' + (processAttendees(event.attendees).length - 2)"
                [pTooltip]="
                  getRemainingAttendeesTooltip(
                    processAttendees(event.attendees)
                  )
                "
                tooltipPosition="top"
                styleClass="remaining-count"
                shape="circle"
                size="normal"
              >
              </p-avatar>
            </p-avatarGroup>
            <!-- <span class="text-sm text-gray-600">
              {{processAttendees(event.attendees).length}} attendee
            </span> -->
          </div>
        </td>
        <td>{{ event.calendarEvent?.createdByName }}</td>
        <td>{{ event.calendarEvent?.createdDate | localDate:'date'}}</td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="cols.length">No Events Found...</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<ng-container *ngIf="displayAddEventModal && selectedAccount">
  <app-lion-shared-events
    [displayAddEvent]="displayAddEventModal"
    [isViewMode]="isViewMode"
    [objectId]="editObjectId"
    [isUserCalendar]="isUserCalendar"
    [usersInCalendar]="usersInCalendar"
    [selectedObject]="selectedAccount"
    [objectTypeId]="objectTypeId"
    (cancelEvent)="cancelEvent()"
    [eventFromModule]="eventFromModule"
    (completeEvent)="fetchEvents(); cancelEvent()"
    [selectedChannel]="{id: channelId}"
    [event] = "selectedEvent?.calendarEvent"
    [mode]="eventMode"
    [isSidebar]="isSidebar"
  >
  </app-lion-shared-events>
</ng-container>
